import { render } from "./WarrantyIcon.vue?vue&type=template&id=ac57958e"
const script = {}
script.render = render

export default script